import { wsService } from "./wsService";
import sections from "@/constants/sections";

const section = sections.SECTION_LOGS;

function list(param = {}) {
  return wsService.make_post_request(section + "/list", param);
}

function filter(param = {}) {
  return wsService.make_post_request(section + "/filter", param);
}

export const documentLogService = {
  list,
  filter,
};
